import React from "react";
import { formatCurrency } from "../../core/currency.core";
import { UserMembership } from "../../types/checkout";
import { MembershipDiscountBadge } from "./membershipDiscountBadge.comp";

interface GuruDollarDisplayProps {
  membership: UserMembership | null;
  amount?: number | null;
  className?: string;
  showLabel?: boolean;
  quantity?: number;
}

export default function MembershipPriceDisplay({
  membership,
  amount,
  className = "",
  showLabel = true,
  quantity,
}: GuruDollarDisplayProps) {
  // If explicit amount is provided, use that; otherwise use the value from context
  const displayAmount = amount !== undefined && amount !== null ? amount : 0;

  // Format the amount
  const formattedAmount = isNaN(displayAmount) ? 0 : displayAmount;

  return (
    <div className={`guru-dollar-display flex items-center ${className}`}>
      {showLabel ? (
        <span className="text-gray-700 font-medium">
          <MembershipDiscountBadge membership={membership} />{" "}
          {formatCurrency(formattedAmount, "HKD")}
          {quantity && quantity > 1 && <span className="ml-1">x {quantity}</span>}
        </span>
      ) : (
        <span className="text-gray-700 font-medium">
          {formatCurrency(formattedAmount, "HKD")}
          {quantity && quantity > 1 && <span className="ml-1">x {quantity}</span>}
        </span>
      )}
    </div>
  );
}
